export default "__VITE_ASSET__BXa2t9vS__"